import {
  ChangeDetectionStrategy,
  Component,
  input,
  WritableSignal,
} from '@angular/core';
import { SharedModule } from '@app/shared';
import { TuiButton } from '@taiga-ui/core';
import { TuiExpand } from '@taiga-ui/experimental';
import { TuiChevron } from '@taiga-ui/kit';

interface NavItem {
  href?: string;
  label: string;
  target?: '_blank' | '_self';
  expanded?: WritableSignal<boolean>;
  items?: {
    href: string;
    label: string;
    target: '_blank' | '_self';
  }[];
}

@Component({
  selector: 'app-sidebar',
  imports: [SharedModule, TuiButton, TuiChevron, TuiExpand],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  public readonly navItems = input.required<NavItem[]>();

  protected toggleExpand(item: NavItem): void {
    item.expanded?.update(value => !value);
  }
}
